export default "__VITE_ASSET__DbpykHhS__"